(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/with-global-event/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/utils/with-global-event/assets/javascripts/prescript.js');

svs.utils = svs.utils || {};


 })(window);